new Splide('.splide-article-picker', {
    perPage: 3,
    perMove: 1,
    gap: 32,
    arrows: true,
    pagination: true,
    arrowPath: 'M0.589844 10.58L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.58Z',
    padding: {left: '0rem', right: '0rem'},

    breakpoints: {

        480: {
            perPage: 1,
            padding: {left: '1.5rem', right: '3rem'},
        },

        720: {
            perPage: 1,
            padding: {left: '1.5rem', right: '12rem'},
        },

        983: {
            perPage: 2,
            padding: {left: '2rem', right: '6rem'},
        },

        1163: {
            perPage: 2,
            gap: 24,
            padding: {right: '12rem'},
        },
        1400: {
            arrows: false,
        },

    },
    classes: {
        arrows: 'splide__arrows w-full px-6 sm:px-8 md:px-0 top-[50%] -mt-4 absolute z-0 justify-between flex gap-4',
        arrow: 'splide__arrow items-center',
        prev: 'splide__arrow--prev relative bg-white',
        next: 'splide__arrow--next bg-white',
        // Add classes for pagination.
        pagination: 'splide__pagination px-6 sm:px-8 md:px-0 !block !-bottom-6 text-center mb-0', // container
        page: 'splide__pagination__page !w-2 !h-2 rounded-full', // each button
    },
}).mount();
//# sourceMappingURL=splide-article-picker.js.map
